import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";
import {
  FaFacebookF,
  FaGithub,
  FaLinkedinIn,
  FaMediumM,
  FaStackOverflow,
  FaWhatsapp,
} from "react-icons/fa";
import { SiHackerrank } from "react-icons/si";

function AnimatedLetter({ char, delay }) {
  // If the character is a space, return a simple span with extra width.
  if (char === " ") {
    return (
      <span
        style={{
          display: "inline-block",
          width: "0.5em", // Adjust the width to control spacing between words
        }}
      >
        &nbsp;
      </span>
    );
  }

  const controls = useAnimation();

  useEffect(() => {
    // First, the initial falling effect.
    controls
      .start({
        y: 0,
        opacity: 1,
        transition: { duration: 0.5, delay, ease: "easeOut" },
      })
      .then(() => {
        // After the initial animation, start the continuous bounce.
        controls.start({
          y: [0, 7, 0],
          transition: {
            duration: 0.7,
            ease: "easeInOut",
            repeat: Infinity,
          },
        });
      });
  }, [controls, delay]);

  return (
    <motion.span
      style={{ display: "inline-block" }} // Ensures proper transform behavior
      initial={{ y: -50, opacity: 0 }}
      animate={controls}
      className="hero--section-title--color"
    >
      {char}
    </motion.span>
  );
}

export default function HeroSection() {
  const title = "Full Stack Developer".split("");

  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hey, I'm Shanaka</p>
          <h1 className="hero--section--title">
            {title.map((char, index) => (
              <AnimatedLetter key={index} char={char} delay={index * 0.1} />
            ))}
          </h1>
          <p className="hero--section-description">
            Software Engineer, Freelancer
            <br /> Full Stack Developer, Odoo Developer
          </p>

          {/* Social Media Icons */}
          <div className="social-icons" style={styles.socialIcons}>
            <a
              href="https://web.facebook.com/shanaka.prince"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
            >
              <FaFacebookF />
            </a>
            <a
              href="https://github.com/shanakasp"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
            >
              <FaGithub />
            </a>
            <a
              href="https://www.linkedin.com/in/shanaka-prince-810400226/"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://wa.me/94769125141"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://medium.com/@shanakaprince"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
            >
              <FaMediumM />
            </a>
            <a
              href="https://stackoverflow.com/users/17394517/shanaka-prince"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
            >
              <FaStackOverflow />
            </a>
            <a
              href="https://www.hackerrank.com/profile/shanakaprince"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
            >
              <SiHackerrank />
            </a>
          </div>
        </div>
        {/* <button className="btn btn-primary">Get In Touch</button> */}
      </div>
      <div
        className="hero--section--img"
        style={{
          backgroundImage: "url('./img/cover2.jpg')",
          backgroundSize: "contain",
          backgroundPosition: "left",
          backgroundRepeat: "no-repeat",
          width: "100%", // Responsive width
          maxWidth: "950px", // Limits max width on large screens
          height: "auto", // Keeps aspect ratio
          minHeight: "500px", // Ensures it doesn't get too small
          borderRadius: "15%", // Rounded corners
        }}
      ></div>
    </section>
  );
}

const styles = {
  socialIcons: {
    marginTop: "2rem",
    display: "flex",
    gap: "1rem",
  },
  iconLink: {
    color: "#000", // black icon
    fontSize: "1.5rem",
    transition: "color 0.3s, transform 0.3s",
  },
};

// Adding hover effects via inline styles using a simple approach.
// You can alternatively add these effects in your CSS file.
const iconLinkHover = `
  .social-icons a:hover {
    color: #555; /* dark grey on hover */
    transform: scale(1.1);
  }
`;

// Injecting the hover style into the document head.
if (typeof document !== "undefined") {
  const styleTag = document.createElement("style");
  styleTag.innerHTML = iconLinkHover;
  document.head.appendChild(styleTag);
}
